module.exports = __webpack_public_path__ + "img/emoji-4.53d97cfd.png";